module.exports = __webpack_public_path__ + "img/checkboxCheck.a0d38bc3.png";